
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/balance",
      function () {
        return require("private-next-pages/balance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/balance"])
      });
    }
  